<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >

    <div class="vb-dialog vb-dialog-danger">
    <v-card class="vb-select-folder-card" data-cy="dialog---">
      <v-card-title class="d-flex justify-space-between" data-cy="dialog---">
        {{$t('routes.users.deleteAccessPoint')}}

        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text scrollable  class="scrollable mt-2 pb-0">
        <div>{{ $t('routes.users.confirmAccesspointDelete') }}</div>

        <!-- <div v-show="successMessage" class="success" data-cy="dialog-createTranscript-successMessage">{{successMessage}}</div> -->
        <div v-show="errorMessage" class="bg-error" data-cy="dialog-createTranscript-errorMessage">{{errorMessage}}</div>
        <div v-if="errorTranslatable" class="bg-error">
          {{$replaceT(errorTranslatable.code, errorTranslatable.params, errorTranslatable.content)}}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="deleteAccessPoint"
          :disabled="deleteButtonDisabled"
          class="btnOk"
          elevation="0"
          data-cy="dialog---"
        >
          {{$t('common.delete')}}
        </v-btn>
        <v-btn variant="text" @click="close" data-cy="dialog---">{{$t('common.cancel')}}</v-btn>
      </v-card-actions>
    </v-card>
    </div>

  </v-dialog>
</template>

<script>
import { useUserStore } from '@/stores/UserStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["dialogClosed", 'update:modelValue'],
  mixins: [DialogActionKeys],
  name: "AccesspointDeleteDialog",

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    nodeId: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      // dialog: false,
      errorMessage: '',
      errorTranslatable: null,
      deleteButtonDisabled: false,
    };
  },

  watch: {
    showDialog(newValue) {
      if (newValue) {
        this.resetDialog();
      }
    }
  },

  methods: {
    resetDialog() {
      this.errorMessage = '';
      this.errorTranslatable = null;
      this.deleteButtonDisabled = false;
    },
    close() {
      this.showDialog = false;
      this.$emit('dialogClosed', true);
    },
    deleteAccessPoint() {
      this.deleteButtonDisabled = true;

      let self = this;
      const payload = {
        userid: this.user.id,
        nodeid: this.nodeId,
      };

      const userStore = useUserStore();
      userStore.deleteAccesspoint(payload)
      .then(function() {
        self.close();
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          const apiError = error.response.data.error.message;
          if (typeof apiError == 'object') {
            self.errorTranslatable = apiError;
          } else {
            self.errorMessage = apiError;
          }
        } else {
          self.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      });


    }
  },

  computed: {
    showDialog: {
      get () {
        return this.modelValue;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>
